import { EventTypeEnum, TriggerSourceEntityTypeEnum } from '@osos/shared/types';

export namespace ReactionActions {
  export class GetTriggerSchemas {
    static readonly type = '[Reaction] Get Trigger Schemas';
    constructor(
      public entity: string,
      public trigger: string,
    ) {}
  }

  export class GetCustomFunctions {
    static readonly type = '[Reaction] Get Custom functions';
  }

  export class GetTriggerEventSchemas {
    static readonly type = '[Reaction] Get Trigger Event Schemas';
    constructor(
      public entity: string,
      public eventType: EventTypeEnum,
      public newTriggerId: string,
    ) {}
  }
  export class GetTriggerSourceSchemas {
    static readonly type = '[Reaction] Get Trigger Source Schemas';
    constructor(
      public entity: string,
      public sourceType: TriggerSourceEntityTypeEnum,
      public sourceId: string,
      public triggerId: string,
    ) {}
  }
}
